import { __assign, __rest } from "tslib";
import React from 'react';
import { useTranslation } from 'react-i18next';
import PaywallLayout from './PaywallLayout';
import { ProfileOwnerWatchButton } from '../../../../Button';
import s from './Paywall.scss';
var WatchersOnlyPaywall = function (_a) {
    var author = _a.deviation.author, deviation = _a.deviation, props = __rest(_a, ["deviation", "deviation"]);
    var t = useTranslation().t;
    return (React.createElement(PaywallLayout, __assign({ deviation: deviation, icon: React.createElement("div", { className: s['watchers-icon'] }), title: t('deviationview.paywall.artstage.watchersOnly.title'), text: t('deviationview.paywall.artstage.watchersOnly.text'), button: author && (React.createElement(ProfileOwnerWatchButton, { className: s['watch-button'], user: author, onToggleWatchSuccess: function () {
                window.location.href = deviation.url;
            } })) }, props)));
};
WatchersOnlyPaywall.displayName = 'WatchersOnlyPaywall';
export default WatchersOnlyPaywall;
//# sourceMappingURL=WatchersOnlyPaywall.js.map